/**
 * Announces a block of loading placeholders as busy without reading out every
 * grey box. The label is carried twice on purpose: as `aria-label`, because
 * `role="status"` takes its accessible name from the author and Home mounts
 * three of these regions at once; and as a visually hidden text node, because a
 * live region is announced from its *contents* — a region holding nothing but
 * `Skeleton` divs has nothing to read out. The text node is rendered last
 * because `space-y-*` puts its margin on every child but the first — leading
 * with it would push the real content down.
 */
export const SkeletonRegion = ({
  children,
  label,
  ...props
}: React.ComponentProps<'div'> & { label: string }) => (
  <div aria-busy aria-label={label} role="status" {...props}>
    {children}

    <span className="sr-only">{label}</span>
  </div>
);
